/**
 * Chip de estado usado nos cabeçalhos de seção e nos cards de plano.
 *
 * As quatro variantes cobrem os rótulos que o spec pede: "Pré-preenchido"
 * (verde), "Atualização necessária" (âmbar), "Seu plano atual" (roxo da marca) e
 * "Disponível" (azul).
 */

import { ReactNode } from "react";
import styled from "styled-components";

import { COLORS } from "../tokens";

export type StatusChipTone =
  | "success"
  | "warning"
  | "brand"
  | "info"
  | "infoSolid";

const TONE_COLORS: Record<
  StatusChipTone,
  { background: string; text: string }
> = {
  success: { background: COLORS.successSoft, text: COLORS.successInk },
  warning: { background: COLORS.warningSoft, text: COLORS.warningInk },
  brand: { background: COLORS.brandSoft, text: COLORS.brandInk },
  info: { background: COLORS.infoSoft, text: COLORS.infoInk },
  /** Badges dos cards de plano no Figma: ciano preenchido, texto branco. */
  infoSolid: { background: COLORS.info, text: COLORS.surface },
};

const Chip = styled.span<{ $tone: StatusChipTone }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  background-color: ${({ $tone }) => TONE_COLORS[$tone].background};
  color: ${({ $tone }) => TONE_COLORS[$tone].text};
`;

interface IProps {
  tone: StatusChipTone;
  children: ReactNode;
}

export function StatusChip({ tone, children }: IProps) {
  return <Chip $tone={tone}>{children}</Chip>;
}
